import React, { memo } from 'react';
import { TransitionGroup } from 'react-transition-group';
const Fade = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(TransitionGroup, {
    component: null,
    appear: true
  }, children);
};
export default /*#__PURE__*/memo(Fade);